// extracted by mini-css-extract-plugin
export var content = "Hero-module--content--9ef7f";
export var featuredImg = "Hero-module--featuredImg--5ed29";
export var featuredImgWrapper = "Hero-module--featuredImgWrapper--07a00";
export var featuredIn = "Hero-module--featuredIn--ddb7f";
export var featuredLogosWrapper = "Hero-module--featuredLogosWrapper--1f1d9";
export var featuredTitle = "Hero-module--featuredTitle--55906";
export var featuredWrapper = "Hero-module--featuredWrapper--cdb0a";
export var heroTitle = "Hero-module--heroTitle--b5680";
export var heroWrapper = "Hero-module--heroWrapper--687b6";
export var iframe = "Hero-module--iframe--adf65";
export var iframeBox = "Hero-module--iframeBox--b2429";
export var lastItem = "Hero-module--lastItem--555fa";
export var newsLogo = "Hero-module--newsLogo--9cdfc";
export var newsLogos = "Hero-module--newsLogos--cc128";
export var start = "Hero-module--start--b8851";
export var xcadDescription = "Hero-module--xcadDescription--c37a5";
export var xcadPrice = "Hero-module--xcadPrice--58de5";